import { Box, Paper, Typography } from "@mui/material";
import { useState } from "react";
import ProductDetails from "./ProductDetails";
import BlurhashImage from "components/BlurhashImage";

const Product = ({ data, custom }) => {
  const [productDetailsOpen, setproductDetailsOpen] = useState(false);

  return (
    <>
      <Box
        elevation={6}
        display="flex"
        flexDirection="column"
        gap="10px"
        maxWidth={custom ? "1100px" : "400px"}
        minHeight={custom ? "424.92px" : "172.41px"}
        alignItems="center"
        sx={{
          transition: "transform 0.2s",
          "&:hover": {
            transform: "scale(1.03)",
            cursor: "pointer",
          },
        }}
        onClick={() => setproductDetailsOpen(true)}
      >
        <BlurhashImage
          src={data.image}
          blurhash={data.blurhash}
          alt="thumbnail"
          width={custom ? "auto" : "400px"}
          height={custom ? "424.92px" : "232px"}
          style={{ borderRadius: "10px" }}
        ></BlurhashImage>
        {!custom && <Typography>{data.display_name}</Typography>}
      </Box>
      <ProductDetails
        data={data}
        open={productDetailsOpen}
        setOpen={setproductDetailsOpen}
      />
    </>
  );
};

export default Product;
